// General
import "./smoking-filter.scss";
import { useEffect } from "react";
// Services
import { useLazyGetJourneyQuestionsQuery } from "../../../../../services/data.service";
// Static Data
import searchConst from "../../../../../const/searchConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateSmokingData,
  updateSmokingSelected,
} from "../../../../../redux/store/searchFilterStore";
import { updateSmokingFilterDialog } from "../../../../../redux/store/dialogStore";
// Material UI
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// i18next
import { useTranslation } from "react-i18next";
// Components
import Spinner from "../../spinner/spinner";

const SmokingFilter = (props) => {
  const { type, enableTitle = true } = props;

  // API variables
  const [
    getJourneyQuestions,
    {
      data: getJourneyQuestionsData,
      error: getJourneyQuestionsErrorData,
      isFetching: getJourneyQuestionsFetching,
      isLoading: getJourneyQuestionsLoading,
      isSuccess: getJourneyQuestionsSuccess,
      isError: getJourneyQuestionsError,
    },
  ] = useLazyGetJourneyQuestionsQuery();

  // Redux variables
  const smokingData = useSelector((state) => state.searchFilter.smokingData);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Lifecycle | Mounted
  useEffect(() => {
    getJourneyQuestions(null, true);
  }, []);

  // Lifecycle | Check for update | getJourneyQuestions API Response
  useEffect(() => {
    if (getJourneyQuestionsFetching || getJourneyQuestionsLoading) {
    } else if (getJourneyQuestionsSuccess) {
      if (smokingData?.length > 0) return;

      let tempSmokingData = getSmokingData()?.map((item) => ({
        ...item,
        isSelected: false,
      }));
      dispatch(updateSmokingData(tempSmokingData));
    } else if (getJourneyQuestionsError) {
    }
  }, [
    getJourneyQuestionsFetching,
    getJourneyQuestionsLoading,
    getJourneyQuestionsSuccess,
    getJourneyQuestionsError,
  ]);

  // Lifecycle | Check for update | smokingData
  useEffect(() => {
    dispatch(updateSmokingSelected(getSelectedSmoking()));
  }, [smokingData]);

  // Event Handlers | MUI Checkbox
  const onCheckboxChange = (id) => (event) => {
    const updatedSmokingData = smokingData?.map((item) =>
      item.id === id ? { ...item, isSelected: event.target.checked } : item
    );
    dispatch(updateSmokingData(updatedSmokingData));
  };

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateSmokingFilterDialog(false));
  };

  // Utility Functions
  const getSmokingData = () => {
    return getJourneyQuestionsData?.selections?.find(
      (item) => item?.category === "smoking"
    )?.selections;
  };
  const getSelectedSmoking = () => {
    return smokingData?.filter((item) => item.isSelected);
  };

  return (
    <div id="smoking-filter-shared-component">
      {enableTitle && (
        <div className="dialog-header">
          <div className="title">{t("filter.smoking")}</div>

          <div className="close-button-container">
            <CloseIcon className="close-button" onClick={onCloseDialog} />
          </div>
        </div>
      )}

      <div className="padding-container">
        {smokingData?.length > 0 ? (
          <div
            className={`checkbox-container ${
              type === searchConst.searchFilterType.full ? "flexwrap" : ""
            }`}
          >
            {smokingData?.map((smoking, index) => (
              <FormGroup className="checkbox" key={index}>
                <FormControlLabel
                  control={
                    <Checkbox
                      className={`custom-checkbox ${
                        type === searchConst.searchFilterType.full
                          ? "custom-checkbox-no-padding"
                          : ""
                      }`}
                      size={
                        type === searchConst.searchFilterType.full
                          ? "small"
                          : "medium"
                      }
                      checked={smoking?.isSelected}
                      onChange={onCheckboxChange(smoking?.id)}
                    />
                  }
                  label={
                    <span
                      className={
                        type === searchConst.searchFilterType.full
                          ? "checkbox-font"
                          : ""
                      }
                    >
                      {smoking?.display_locale}
                    </span>
                  }
                />
              </FormGroup>
            ))}
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default SmokingFilter;
